import { Component, HostListener, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuthStateService } from 'src/app/core/auth/auth-state.service';
import { UserService } from '../../../core/services/user.service';
import { PolicyStatus } from '../../../shared/enums/policy_status';
import { FormatService } from '../../../shared/utils/formatting-function';

/** Report tabs live in ./components; this page holds the shared filter data and the loading dialog. */
@Component({
    selector: 'app-reports-page',
    templateUrl: './reports-page.component.html',
    styleUrls: ['./reports-page.component.scss'],
    providers: [MessageService, FormatService],
})
export class ReportsPageComponent implements OnInit {
    visible = false;
    loadingMessage = 'Initializing Report';
    screenWidth: number = window.innerWidth;
    loggedInUser!: any;

    users: any[] = [];
    policyStatuses: any[] = [];
    canFilterByUser = false;

    constructor(
        private authStateService: AuthStateService,
        private messageService: MessageService,
        private userService: UserService
    ) {}

    ngOnInit(): void {
        this.loggedInUser = this.authStateService.getLoggedInUser();
        this.canFilterByUser =
            this.authStateService.checkUserPermission('manage_users') ||
            this.authStateService.checkUserPermission('can_report_all_sales');
        this.loadPolicyStatuses();
        this.loadUsers();
    }

    @HostListener('window:resize')
    handleResize(): void {
        this.screenWidth = window.innerWidth;
    }

    /** Shows the loading dialog with the given message, or hides it when null. */
    onLoadingChange(message: string | null): void {
        if (message === null) {
            this.visible = false;
            return;
        }
        this.loadingMessage = message;
        this.visible = true;
    }

    private loadUsers(): void {
        const body = { partnerBranchId: this.loggedInUser['partner_branch_id'] };
        this.visible = true;
        this.userService.listUsers(body).subscribe({
            next: (value) => {
                this.users = value.users.map((user) => ({
                    label: user.username,
                    value: user.externalSystemId,
                }));
                this.visible = false;
            },
            error: (err) => {
                this.visible = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.message });
            },
        });
    }

    private loadPolicyStatuses(): void {
        this.policyStatuses = Object.values(PolicyStatus)
            .filter((value) => typeof value !== 'number')
            .map((value) => ({
                label: value.toString().replace(/_/g, ' '),
                value,
            }));
    }
}
